<template>
  <div class="tab-button" @click="handleClick" :class="getClass">
    <div class="tab-button-inuse" v-if="show">{{ $bus.transify['FESTA_USE_COUPON'] ? $bus.transify['FESTA_USE_COUPON'] : 'FESTA_USE_COUPON' }}</div>
    <template v-else>
      <div class="tab-button-title" :class="getTitleClass">{{ getTitle }}</div>
      <div class="tab-button-discount">
        <ScrollNumber :target="discount" :percent="true" :shopType="shopType" />
        <div class="tab-button-discount-text" :class="getDiscountTextClass">{{ $bus.transify['FESTA_BUTTON_DISCOUNT'] }}</div>
      </div>
    </template>
    <div class="tab-button-light" v-show="!$bus.isFirst" :class="getLightClass"></div>
  </div>
</template>

<script>
import ScrollNumber from '@/components/base/scroll-number'
import { addGA } from '@/utils/assist'

export default {
  props: {
    shopType: String,
    discount: Number,
    show: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ScrollNumber
  },
  computed: {
    getTitle () {
      const { shopType } = this
      if (shopType === 'food') {
        return this.$bus.transify['FESTA_SHOP_A'] ? this.$bus.transify['FESTA_SHOP_A'] : 'FESTA_SHOP_A'
      }
      if (shopType === 'fishing') {
        return this.$bus.transify['FESTA_SHOP_B'] ? this.$bus.transify['FESTA_SHOP_B'] : 'FESTA_SHOP_B'
      }
      if (shopType === 'shoot') {
        return this.$bus.transify['FESTA_SHOP_C'] ? this.$bus.transify['FESTA_SHOP_C'] : 'FESTA_SHOP_C'
      }
    },
    getTitleClass () {
      return {
        [`tab-button-title-${this.shopType}-noactive`]: true,
        [`tab-button-title-${this.shopType}-active`]: this.shopType === this.$bus.shopType && !this.$bus.isFirst
      }
    },
    getDiscountTextClass () {
      return {
        [`tab-discount-text-${this.shopType}-noactive`]: true,
        [`tab-discount-text-${this.shopType}-active`]: !this.$bus.isFirst && this.$bus.shopType === this.shopType
      }
    },
    getClass () {
      return {
        [`tab_button_disabled_${this.shopType}`]: true,
        [`tab-button-${this.shopType}`]: !this.$bus.isFirst && this.$bus.shopType === this.shopType
      }
    },
    getLightClass () {
      return {
        [`tab-button-light-${this.shopType}`]: this.$bus.shopType === this.shopType
      }
    }
  },
  methods: {
    hide () {
      clearTimeout(this.$bus.timer)
      this.$bus.timer = setTimeout(() => {
        this.$bus.expand = false
        clearTimeout(this.$bus.timer)
        this.$bus.timer = null
      }, 4000)
    },
    handleDialogCharacterTextStatus () {
      const index = this.$bus.mapShopTypeToDiscount(this.$bus.shopType)
      this.$bus.expand = true
      this.hide()

      // 判断是否已经购买了所有物品
      if (this.$bus.isPurchaseAll()) {
        this.$bus.dialogCharacterTextStatus = 'all'
        return
      }

      // 使用中
      if (this.$bus[`inuse${this.$bus.shopType}`]) {
        this.$bus.dialogCharacterTextStatus = 'bigDiscount'
        return
      }

      // 已经购买过，但是还未超出limit
      if (this.$bus.currentCost > 0 && this.$bus.currentCost < this.$bus.costLimit[index]) {
        this.$bus.dialogCharacterTextStatus = 'purchase'
        return
      }
      // 满足条件，但是没抽取
      if (this.$bus.currentCost >= this.$bus.costLimit[index] && this.$bus.bigDiscount[index] !== -1) {
        this.$bus.dialogCharacterTextStatus = 'ticket'
        return
      }
      // 判断是否购买了物品
      if (this.$bus.bigDiscount[index] === -1) {
        this.$bus.dialogCharacterTextStatus = 'purchase'
        return
      }

      this.$bus.dialogCharacterTextStatus = `welcome${this.$bus.shopType}`
    },
    handleClick () {
      const { shopType } = this
      addGA(`switch-shop-${shopType}`, 'click')
      // 抽取折扣期间
      if (this.$bus.isFirst) {
        return
      }
      //  切换商店
      const currentShopType = this.$bus.shopType
      if (currentShopType !== shopType) {
        this.$bus.shopType = shopType

        // 获取当前 shopType 对应的 discount
        const discount = this.$bus.discount[this.$bus.mapShopTypeToDiscount(shopType)]

        // 获取shopType对应的index
        const index = this.$bus.mapShopTypeToDiscount(shopType)

        // update currentCost
        this.$bus.currentCost = this.$bus.cost[index]
        if (this.$bus.currentCost >= this.$bus.costLimit[index] && this.$bus.bigDiscount[index] !== -1 && !this.$bus[`inuse${this.$bus.shopType}`]) {
          this.$bus.ticketBgMarkFlag = true
        } else {
          this.$bus.ticketBgMarkFlag = false
        }

        // update currentDiscount
        const currentBigDiscount = this.$bus.bigDiscount[index]
        // 或者通过inuse变量来控制
        if (currentBigDiscount !== 0 && currentBigDiscount !== -1 && !this.$bus.ticketBgMarkFlag) {
          this.$bus.currentDiscount = currentBigDiscount
        } else {
          this.$bus.currentDiscount = discount
        }

        this.handleDialogCharacterTextStatus()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tab-button {
  position: relative;
  @include flexcc;
  @include px2res(width, 221);
  @include px2res(height, 85);

  .tab-button-light {
    position: absolute;
    @include px2res(top, -9);
    @include px2res(left, -8);
    @include px2res(width, 239);
    @include px2res(height, 101);
    z-index: -1;
  }

  /* &.tab-button-food {
    @include px2res(-webkit-text-stroke-width, 1);
    -webkit-text-stroke-color: #86390F;
  }

  &.tab-button-fishing {
    @include px2res(-webkit-text-stroke-width, 1);
    -webkit-text-stroke-color: #86390F;
  }

  &.tab-button-shoot {
    @include px2res(-webkit-text-stroke-width, 1);
    -webkit-text-stroke-color: #86390F;
  } */

  .tab-button-title {
    font-family: $main-font-family;
    font-weight: 300;
    @include px2res(font-size, 20);

    &.tab-button-title-food-noactive {
      color: #0877A2;
    }

    &.tab-button-title-fishing-noactive {
      color: #9A8F10;
    }

    &.tab-button-title-shoot-noactive {
      color: #D44D07;
    }

    &.tab-button-title-food-active {
      @include text-gradient(0deg,#074C82 0%, #03253E 100%);
      filter: drop-shadow(1px 0px 0px #00FFF0) drop-shadow(-1px 0px 0px #00FFF0)
        drop-shadow(0px 1px 0px #00FFF0) drop-shadow(0px -1px 0px #00FFF0);
    }

    &.tab-button-title-fishing-active {
      @include text-gradient(0deg,#B44E0F 0%, #5E2608 100%);
      filter: drop-shadow(1px 0px 0px #fffc00) drop-shadow(-1px 0px 0px #fffc00)
        drop-shadow(0px 1px 0px #fffc00) drop-shadow(0px -1px 0px #fffc00);
    }

    &.tab-button-title-shoot-active {
      @include text-gradient(0deg,#B44E0F 0%, #5A2507 100%);
      filter: drop-shadow(1px 0px 0px #F5EA00) drop-shadow(-1px 0px 0px #F5EA00)
        drop-shadow(0px 1px 0px #F5EA00) drop-shadow(0px -1px 0px #F5EA00);
    }
  }

  .tab-button-discount {
    display: flex;

    .tab-button-discount-text {
      @include px2res(font-size, 30);
      font-family: $main-font-family;

      &.tab-discount-text-food-noactive {
        color: #0877A2;
      }

      &.tab-discount-text-fishing-noactive {
        color: #9A8F10;
      }

      &.tab-discount-text-shoot-noactive {
        color: #D44D07;
      }

      &.tab-discount-text-food-active {
        @include text-gradient(0deg,#074C82 0%, #03253E 100%);
        filter: drop-shadow(1px 0px 0px #00FFF0) drop-shadow(-1px 0px 0px #00FFF0)
        drop-shadow(0px 1px 0px #00FFF0) drop-shadow(0px -1px 0px #00FFF0);
      }

      &.tab-discount-text-fishing-active {
        @include text-gradient(0deg,#B44E0F 0%, #5E2608 100%);
        filter: drop-shadow(1px 0px 0px #fffc00) drop-shadow(-1px 0px 0px #fffc00)
        drop-shadow(0px 1px 0px #fffc00) drop-shadow(0px -1px 0px #fffc00);
      }

      &.tab-discount-text-shoot-active {
        @include text-gradient(0deg,#B44E0F 0%, #5A2507 100%);
        filter: drop-shadow(1px 0px 0px #F5EA00) drop-shadow(-1px 0px 0px #F5EA00)
        drop-shadow(0px 1px 0px #F5EA00) drop-shadow(0px -1px 0px #F5EA00);
      }
    }
  }

  .tab-button-inuse {
    font-family: $main-font-family;
    font-weight: 300;
    @include px2res(font-size, 30);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/business-base/tab-button/index.vue